module.exports = __webpack_public_path__ + "ab716887b5e030bc20763b173e01a195.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/trumpet-button.png
// module id = 127
// module chunks = 0